module.exports = __webpack_public_path__ + "static/img/pay_qrpay_pic@3x.9716d32.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/pay_qrpay_pic@3x.png
// module id = S2VX
// module chunks = 1